import React from "react";
import { Link } from "react-router";
import {
  Menu,
  MenuItem,
  Paper,
  Divider,
  IconButton,
  SvgIcon
} from "material-ui";
import assign from "lodash/assign";

import { spacing as Spacing, colors as Colors } from "material-ui/styles";
import withWidth, { SMALL, MEDIUM, LARGE } from "material-ui/utils/withWidth";

import MenuInsetDivider from "./partials/menu-inset-divider.jsx";
import UserActions from "../actions/UserActions";

const SIDEBAR_STATE_LOCALSTORAGE_KEY = "eventive--sidebarCollapsed";

let initialSidebarCollapsedState = false;
try {
  let rawValue = window.localStorage.getItem(SIDEBAR_STATE_LOCALSTORAGE_KEY);
  if (typeof rawValue !== "undefined") {
    initialSidebarCollapsedState = JSON.parse(rawValue);
  }
} catch (e) {
  // fall through
}
window.__eventiveSidebarCollapsed = initialSidebarCollapsedState;

class PageWithNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openedCollapsibles: {},
      sidebarCollapsed: initialSidebarCollapsedState,
      sidebarTemporarilyOpened: false,
      justChangedSidebar: false,
      justMounted: true
    };

    this._onScrollNav = this._onScrollNav.bind(this);
    this._onToggleCollapsed = this._onToggleCollapsed.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ justMounted: false }), 100);
  }

  getStyles() {
    let subNavWidth = Spacing.desktopKeylineIncrement * 4 + "px";
    let styles = {
      root: {
        //paddingTop: Spacing.desktopKeylineIncrement + 'px'
      },
      rootWhenMedium: {
        position: "relative"
      },
      secondaryNav: {
        borderTop: "solid 1px " + Colors.grey300,
        zIndex: 999
      },
      content: {
        boxSizing: "border-box",
        padding: Spacing.desktopGutter + "px"
        //maxWidth: (Spacing.desktopKeylineIncrement * 14) + 'px'
      },
      secondaryNavWhenMedium: {
        borderTop: "none",
        position: "fixed",
        top: "64px",
        left: "0px",
        width: subNavWidth,
        height: "calc(100vh - 64px)",
        // overflowY: "scroll",
        borderRight: "solid 1px " + Colors.grey300,
        boxShadow:
          "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px"
      },
      contentWhenMedium: {
        transition: this.state.justMounted ? "" : "margin 0.2s ease-in-out",
        marginLeft: this.state.sidebarCollapsed ? "" : subNavWidth,
        padding: "32px",
        minHeight: "85vh"
      },
      menuItem: {
        fontSize: "13px",
        cursor: "pointer",
        padding: 0
      },
      menuItemActive: {
        color: Colors.lightBlue700,
        fontWeight: "500"
        //backgroundColor: 'rgba(33,33,33,0.08)'
      },
      menuItemInner: {
        padding: "0 8px"
      },
      subheaderMenuItem: {
        cursor: "inherit",
        marginLeft: 24
      },
      subheaderMenuItemInner: {
        //color: Colors.lightBlue700,
        color: "rgb(33,33,33)",
        padding: 0,
        fontWeight: "500",
        borderBottom: "1px solid",
        width: 208,
        //display: 'inline-block',
        lineHeight: "36px",
        marginBottom: 6,
        marginTop: 6
      },
      subheaderCollapsible: {}
    };

    if (this.props.width === MEDIUM || this.props.width === LARGE) {
      styles.root = assign({}, styles.root, styles.rootWhenMedium);
      styles.secondaryNav = assign(
        {},
        styles.secondaryNav,
        styles.secondaryNavWhenMedium
      );
      styles.content = assign({}, styles.content, styles.contentWhenMedium);
    }

    return styles;
  }

  render() {
    let styles = this.getStyles();
    let items = this.props.menuItems;

    // add opened collapsibles
    items = items.reduce((f, item) => {
      f.push(item);
      if (item.isCollapsible && this.state.openedCollapsibles[item.key]) {
        f = f.concat(item.subitems);
      }
      return f;
    }, []);

    let menuItems = items.map((x, i) =>
      x.isDivider ? (
        x.inset ? (
          <MenuInsetDivider key={i} />
        ) : (
          <Divider key={i} />
        )
      ) : (
        (() => {
          let menuItem = (
            <MenuItem
              key={i}
              style={assign(
                {},
                styles.menuItem,
                x.isSubheader ? styles.subheaderMenuItem : {},
                x.isFirst ? styles.subheaderFirstMenuItem : {},
                !x.isSubheader &&
                  x.route &&
                  this.context.router.isActive(x.route)
                  ? styles.menuItemActive
                  : {},
                x.isCollapsible && styles.subheaderCollapsible,
                x.disabled && { pointerEvents: "none" }
              )}
              primaryText={
                <div
                  style={assign(
                    {},
                    styles.menuItemInner,
                    x.isSubheader && styles.subheaderMenuItemInner
                  )}
                >
                  {x.isCollapsible
                    ? this.state.openedCollapsibles[x.key]
                      ? "▾ "
                      : "▸ "
                    : ""}
                  {x.text}
                </div>
              }
              disabled={x.isSubheader}
              onClick={
                x.isCollapsible
                  ? () => {
                    let { openedCollapsibles } = this.state;
                    openedCollapsibles[x.key] = !openedCollapsibles[x.key];
                    this.setState({ openedCollapsibles });
                  }
                  : undefined
              }
            />
          );

          if (x.route) {
            return (
              <Link style={{ textDecoration: "none" }} to={x.route}>
                {menuItem}
              </Link>
            );
          } else {
            return menuItem;
          }
        })()
      )
    );

    const isSidebarCollapsed =
      this.props.width !== SMALL &&
      this.state.sidebarCollapsed &&
      !this.state.sidebarTemporarilyOpened;

    return (
      <div style={styles.root}>
        <div style={styles.content} className="print-reset-content">
          {this.props.children}
        </div>
        <div
          style={Object.assign(
            { transition: "margin 0.2s ease-in-out" },
            styles.secondaryNav,
            isSidebarCollapsed && {
              marginLeft: -236
            }
          )}
          onMouseEnter={() => {
            if (!this.state.justChangedSidebar) {
              this.setState({ sidebarTemporarilyOpened: true });
            }
          }}
          onMouseLeave={() => {
            if (!this.state.justChangedSidebar) {
              this.setState({ sidebarTemporarilyOpened: false });
            }
          }}
          className="no-print"
        >
          <Paper
            zDepth={0}
            style={Object.assign(
              {
                position: "relative"
              },
              this.props.width !== SMALL && {
                height: "100%",
                overflowY: isSidebarCollapsed ? "hidden" : "scroll"
              }
            )}
            ref={r => {
              this.secondaryNavContainer = r;
            }}
            onWheel={this._onScrollNav}
          >
            {this.props.width !== SMALL ? (
              <div
                style={{
                  position: "fixed",
                  left: isSidebarCollapsed ? 3 : 239,
                  top: 80,
                  zIndex: 3000,
                  transition: "all 0.2s ease-in-out"
                }}
              >
                <IconButton
                  tooltip={
                    this.state.sidebarCollapsed
                      ? this.state.sidebarTemporarilyOpened
                        ? "Pin sidebar open"
                        : "Expand sidebar"
                      : "Collapse sidebar"
                  }
                  onTouchTap={this._onToggleCollapsed}
                  style={{
                    backgroundColor: "#e5e5e5",
                    border: "1px solid #fff",
                    borderRadius: "100%",
                    width: 36,
                    height: 36,
                    padding: 4
                  }}
                  iconStyle={{ width: 24, height: 24 }}
                  tooltipStyles={{ marginTop: -16, marginLeft: 36 }}
                  tooltipPosition="center-right"
                >
                  {this.state.sidebarCollapsed &&
                    this.state.sidebarTemporarilyOpened ? (
                    <SvgIcon viewBox="0 0 48 48">
                      <path d="M31.7 25.6 36 29.45V32.45H25.5V44.5L24 46L22.5 44.5V32.45H12V29.45L16 25.6V9H13.5V6H34.2V9H31.7ZM16.05 29.45H31.65L28.7 26.7V9H19V26.7ZM23.85 29.45Z" />
                    </SvgIcon>
                  ) : this.state.sidebarCollapsed ? (
                    <SvgIcon viewBox="0 0 48 48">
                      <path d="M6 36V33H42V36ZM6 25.5V22.5H42V25.5ZM6 15V12H42V15Z" />
                    </SvgIcon>
                  ) : (
                    <SvgIcon viewBox="0 0 48 48">
                      <path d="M6 36v-3h26v3Zm0-10.6v-3h20v3ZM6 15v-3h26v3Zm33.9 18.4-9.45-9.45 9.4-9.4L42 16.7l-7.25 7.25 7.3 7.3Z" />
                    </SvgIcon>
                  )}
                </IconButton>
              </div>
            ) : null}
            {/* {isSidebarCollapsed ? (
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 2000,
                  cursor: "pointer"
                }}
                onClick={this._onToggleCollapsed}
              />
            ) : null} */}
            <Menu
              disableAutoFocus={true}
              ref="menuItems"
              listStyle={Object.assign(
                { transition: "opacity 0.2s ease-in-out" },
                isSidebarCollapsed
                  ? { opacity: 0, pointerEvents: "none" }
                  : { opacity: 1 }
              )}
            >
              {menuItems}
            </Menu>
          </Paper>
        </div>
      </div>
    );
  }

  _getSelectedIndex() {
    let menuItems = this.props.menuItems;
    let currentItem;

    for (let i = menuItems.length - 1; i >= 0; i--) {
      currentItem = menuItems[i];
      if (
        currentItem.route &&
        this.context.router.isActive(currentItem.route, currentItem.routeParams)
      )
        return i;
    }
  }

  _onScrollNav(e) {
    // Don't interrupt scrolling on mobile
    if (this.props.width === SMALL) {
      return;
    }

    // Otherwise, ensure that user scrolling within secondary nav doesn't affect rest of the page
    let el = this.secondaryNavContainer,
      hitBottom = el.scrollHeight - el.scrollTop === el.clientHeight,
      hitTop = el.scrollTop === 0,
      scrollingDown = e.deltaY > 0;

    if ((scrollingDown && hitBottom) || (!scrollingDown && hitTop)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  _onToggleCollapsed() {
    const sidebarCollapsed = !this.state.sidebarCollapsed;

    try {
      window.__eventiveSidebarCollapsed = sidebarCollapsed;
      window.localStorage.setItem(
        SIDEBAR_STATE_LOCALSTORAGE_KEY,
        sidebarCollapsed
      );
    } catch (e) {
      // fall through
    }

    // Hack: Refresh user store to trigger App component to re-render footer with
    // appropriate left padding
    UserActions.clearErrors.defer();

    this.setState({
      sidebarCollapsed,
      sidebarTemporarilyOpened: false,
      justChangedSidebar: true
    });

    setTimeout(() => {
      this.setState({ justChangedSidebar: false });
    }, 100);
  }
}

export default withWidth()(PageWithNav);



// WEBPACK FOOTER //
// ./src/app/components/page-with-nav.jsx